const CustomSectionsType = {
  SET_CUSTOM_SECTION_LIST: 'SET_CUSTOM_SECTION_LIST',
  SET_CUSTOM_SECTION_COLUMNS_LIST: 'SET_CUSTOM_SECTION_COLUMNS_LIST',
  SET_EDIT_COLUMN_DATA: 'SET_EDIT_COLUMN_DATA',
  SET_CUSTOM_SECTION_DYNAMIC_COLUMNS: 'SET_CUSTOM_SECTION_DYNAMIC_COLUMNS',
  SET_ALL_MEASUREMENT_DYNAMIC_COLUMNS: 'SET_ALL_MEASUREMENT_DYNAMIC_COLUMNS',
  SET_ALL_CUSTOM_SAMPLES_TRACKING: 'SET_ALL_CUSTOM_SAMPLES_TRACKING',
  SET_SECTIONS_WITH_COLUMNS: 'SET_SECTIONS_WITH_COLUMNS',
  UNMOUNT_CUSTOM_MODAL: 'UNMOUNT_CUSTOM_MODAL',
  CUSTOM_SECTION_BOM_ALL_TYPES: 'CUSTOM_SECTION_BOM_ALL_TYPES',
};

export default CustomSectionsType;
